import * as HttpService from '../HttpService'

let namespace = 'lookups'

let findAll = (cb, errorCb) => {
    HttpService.get(namespace, cb, errorCb)
}

let find = (id, cb, errorCb) => {
    HttpService.get(namespace + '/' + id, cb, errorCb)
}

export {
    find,
    findAll
}



// WEBPACK FOOTER //
// ./src/services/lookup/lookupService.js